import React from 'react';
import ReactDOM from 'react-dom';

class WebAppFeatureTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabId: 'organization-for-home-inspectors'
    }
  }

  tabs = () => {
    return (
      [
        { id: 'organization-for-home-inspectors', label: 'Organization for Home Inspectors' },
        { id: 'organization-for-clients', label: 'Organization for Clients' },
        { id: 'collecting-payments', label: 'Collecting Payments for Home Inspectors' },
        { id: 'analytics', label: 'Analytics for Home Inspectors' },
        { id: 'bookkeeping', label: 'Bookkeeping Reports' },
        { id: 'online-presence', label: 'Online Presence for Home Inspectors' },
        { id: 'marketing', label: 'Marketing' }
      ]
    );
  }

  changeTab = (tabId) => {
    this.setState({ activeTabId: tabId });
  }

  renderTabBody = (tabId) => {
    if(tabId === 'organization-for-home-inspectors') {
      return <OrganizationForHomeInspectors />
    } else if(tabId === 'organization-for-clients') {
      return <OrganizationForClients />
    } else if(tabId === 'collecting-payments') {
      return <CollectingPayments />
    } else if(tabId === 'analytics') {
      return <Analytics />
    } else if(tabId === 'bookkeeping') {
      return <Bookkeeping />
    } else if(tabId === 'online-presence') {
      return <OnlinePresence />
    } else if(tabId === 'marketing') {
      return <Marketing />
    }
  }

  render() {
    const { activeTabId } = this.state;

    return (
      <div className='component-web-app-feature-tabs'>
        <div className='tabs'>
          {
            this.tabs().map((tab) => {
              return (
                <div 
                  key={tab.id} 
                  className={`tab ${(activeTabId === tab.id) ? 'active' : ''}`}
                  onClick={() => { this.changeTab(tab.id)}}
                >
                  {tab.label}
                </div>
              );
            })
          }
            
        </div>
        <div className='tab-body'>
          {this.renderTabBody(activeTabId)}
        </div>
      </div>
    );
  }
}

const OrganizationForHomeInspectors = () => {
  return (
    <div>
      <p>
        An Inspection request or booking typically comes through over the phone, online, text message, email, or through our
        booking request platform. We have organized this process on our online web app to keep track of everything as you go.
      </p>

      <ul>
        <li>If you have multiple inspections they are listed in chronological order on your inspections page</li>
        <li>Inspection can automatically be synced with your calendar through our web app so there is no need to re-enter information</li>
        <li>
          Once you enter the address a clickable direction link associated with the inspection address will take you to your map application
          on your phone so you always know where to go without having to re-enter addresses.
        </li>
        <li>Clients phone number and emails are available at the click of button</li>
        <li>
          Each inspection has its own progress list so you can easily check the status and see if the client has completed theirs steps
          and that the status of the inspection is complete. It confirms the following information at a glance;
          <ul>
            <li>the inspection is ready for the client </li>
            <li>that the client has signed the inspection agreement</li>
            <li>that the client has entered their payment information (or has paid) and that the report has been uploaded for the client.  </li>
          </ul>
        </li>
        <li>Receipts are automatically emailed to the client</li>
      </ul>

      <p>
        All information is automatically communicated to the client via email so there is no need for the home inspector to email or call.
      </p>

    </div>
  );
};

const OrganizationForClients = () => {
  return (
    <div>
      <p>
        Once the home inspection is booked through the online web app clients will receive an initial email thanking them for booking and advising
        them of their payment options. There is a link that will take them to their specific inspection details. Clients will be required to
        sign a home inspection agreement. Once the home inspection report has been completed the inspector will upload it to the web app and the
        client will be notified via email that the report is ready for download and they will be given a link to the report. If the client has
        not signed the inspection agreement or payment has not been made they will be reminded to complete these actions in order to download the report.
      </p>

      <p>
        This means no more having to remember to get them to sign inspection agreements, no more negotiating the cost during the inspection, no more
        chasing clients down for payments, no more having to keep track of  phone numbers, emails, address, expenses, reports, and agreements.
        Everything is organized in real time as you go. The Inspec homes web app even provides analytics and accounting reports so you don’t have to
        worry about it at the end of the year.
      </p>
    </div>
  );
};

const CollectingPayments = () => {
  return (
    <div>
      <p>
        When an inspection is booked with the client they will automatically receive an email explaining their payment options. If they choose to pay
        online through our secure platform, they can enter their payment information online ahead of time. The web app simply stores their payment
        information until you have uploaded their home inspection report. Once the report has been uploaded their credit card will be charged and
        the payment will automatically go to your bank account and the royalty fee will automatically go to Inspec Homes. All this information is
        also stored on our web app so you can review the information online anytime.
      </p>

      <p>
        What if the client does not pay with a credit card? We have thought of that too, as part of your onboarding process with Inspec you will
        link up a bank account and a credit card. Whenever a client pays by cash or e-transfer you simply enter the method of payment and amount
        into the web app. Once the payment information gets entered by the home inspector the clients report becomes available for download and the
        royalty fee is automatically charged to home inspectors credit card.   
      </p>
    </div>
  );
};

const Analytics = () => {
  return (
    <div>
      <p>
        Our web app automatically tracks how many inspections you do, how they were paid, and the total revenue you generated. Reports and graphs
        are available to track exactly how you are doing month by month. Analytics will give you valuable information on how you are performing,
        this is also a great tool for letting you know how your marketing strategies are working, how seasons affect your revenue, how customers
        like to pay, how prices change affect the number of inspections and so much more.
      </p>
    </div>
  );
};

const Bookkeeping = () => {
  return (
    <div>
      <p>
        Every year when accounting season comes it can feel cumbersome to get things ready for your accountant. No matter your fiscal year end,
        Inspec Homes web app can automatically generate revenue reports and receipts for your royalty fees. This saves valuable time and eliminates
        stress. After all you want to spend your time doing home inspections not accounting.
      </p>
    </div>
  );
};

const OnlinePresence = () => {
  return (
    <div>
      <p>
        As time goes on we are seeing more and more business being generated from online sources. The Inspec Homes Website has been created using
        the latest in SEO design and follows a formula to rank high for people looking for home inspections on search engines like google. When
        you don’t have a good website that ranks high people can not find you business, and if you try to advertise online and you don’t have a
        good website you have to pay more and the advertising is less effective. Even if you get recommended to clients by their agents they will
        often check out your online presence to learn more about you. Anyway you slice it, having an online presence is only increasing in importance.
        Home Inspectors can make their own websites but if they are not designed properly, or if they are not being constantly updated with new content
        and improved designs they will quickly become out of date. Managing a good website is expensive and time consuming and not a good use of your time.
        This is another reason why an Inspec Homes franchise is such a great value.
      </p>
    </div>
  );
};

const Marketing = () => {
  return (
    <div>
      <p>
        When it comes to marketing we like to use the 80/20 rule. If 80% of your business comes from your network of real estate agents, and 20% comes
        from online, then you should spend 80% of your time marketing yourself in person, and 20% of your time marketing yourself online. 
        We have a very successful approach to marketing and it is the cornerstone of success in the home inspection industry. We take the time to couch
        you and keep you motivated so that you will become a successful home inspector. 
      </p>

      <p>
        80% of the time you spend marking will be going to real estate agents offices and open houses. You will need to spend time getting to know
        the agents in your area, constant and consistent communication is the key. Our team of successful home inspectors have mastered this and will
        help you to do the same in your territory.
      </p>

      <p>
        20% of the time you spend marketing will be online. This includes creating posts for your Google Business, Instagram, Facebook and the
        Inspec website. Creating contents and emails for marketing to your agents and clients. Online marketing is something that Inspec Homes does
        better than anyone else in the industry. Our website has been designed from top to bottom to be SEO and SEM optimized to ensure that you will
        rank high in an organic search, and to ensure that if you advertise online that your ads will have a high quality score so they are less
        expensive and more effective. We are online and offline marketing experts and will teach you everything you need to know as part of your training.
      </p>

      <p>
        Once you have the knowledge needed to perform home inspections the hardest ongoing task is a successful marketing campaign. Marketing yourself
        effectively is the only way you can be successful. Inspec Homes knows how important marketing is and this is why we spend so much time making
        sure every home inspector is following our proven marketing techniques.
      </p>
    </div>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<WebAppFeatureTabs />, document.getElementById('web-app-feature-tabs-mount-point'));
})
